import React from 'react';
import { Container, Row, Col, Button, Form, Alert } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import { useDetailsCouponQuery, useUpdateCouponMutation } from './couponsApi';
import Loading from '../../app/components/Loading';
import { RequireTier } from '../auth/RequireTier';

function CouponDetails() {
  const params = useParams<{ couponId: string }>();
  const [whitelisted, setWhitelisted] = React.useState<boolean>(false);
  const [description, setDescription] = React.useState<string>('');

  const { data: coupon, isError, isFetching } = useDetailsCouponQuery(params.couponId || '');
  const [updateCoupon, { isLoading: isUpdating, isError: updatingError, isSuccess: updatingSuccess }] =
    useUpdateCouponMutation();

  React.useEffect(() => {
    if (coupon?.whitelisted) setWhitelisted(coupon.whitelisted);
    if (coupon?.description) setDescription(coupon.description || '');
  }, [coupon?.whitelisted, coupon?.description]);

  const onWhitelistedChange = (event: React.ChangeEvent<HTMLInputElement>) => setWhitelisted(event.target.checked);
  const onDescriptionChange = (event: React.ChangeEvent<HTMLInputElement>) => setDescription(event.target.value);
  const onUpdateCoupon = () => {
    if (!coupon) return;

    updateCoupon({ id: coupon?.id, whitelisted, description });
  };

  if (isFetching) {
    return <Loading text="Loading coupon" />;
  }

  if (isError || !coupon) {
    return <Alert variant="danger">An error occured while fetching the coupon</Alert>;
  }

  return (
    <main>
      <h1 className="mb-4">Coupon details</h1>
      {updatingError && <Alert variant="danger">An error occured while updating the coupon</Alert>}
      {updatingSuccess && <Alert variant="success">Updated successfully</Alert>}
      <Container>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>ID</strong>
          </Col>
          <Col xs={10}>
            <span>{coupon.id}</span>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Code</strong>
          </Col>
          <Col xs={10}>
            <span>{coupon.chargebeeCouponId}</span>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Name</strong>
          </Col>
          <Col xs={10}>
            <span>{coupon.displayName}</span>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Created at</strong>
          </Col>
          <Col xs={10}>
            <span>{new Date(coupon.createdAt).toLocaleDateString()}</span>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Synchronized at</strong>
          </Col>
          <Col xs={10}>
            <span>{new Date(coupon.synchronizedAt).toLocaleDateString()}</span>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Short description</strong>
          </Col>
          <Col xs={10}>
            <Form.Control type="text" as="textarea" rows={4} value={description} onChange={onDescriptionChange} />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={2}>
            <strong>Is available</strong>
          </Col>
          <Col xs={10}>
            <Form.Switch checked={whitelisted} onChange={onWhitelistedChange} />
          </Col>
        </Row>
        <Row className="mb-4">
          <Col xs={{ offset: 10, span: 2 }}>
            <RequireTier requiredTier="admin" policy="disable">
              <Button variant="success" disabled={isUpdating} onClick={onUpdateCoupon}>
                Save
              </Button>
            </RequireTier>
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default CouponDetails;
